import type { IntlShape, MessageDescriptor } from 'react-intl';
import { messages } from '../localization/messages.ts';

type ToolNarrationMessageKey =
  | 'screenReady'
  | 'savingDetails'
  | 'passingAlong'
  | 'lookingUp'
  | 'checkingNotes';

export type NarrationMessageKey =
  | 'thinking'
  | 'working'
  | 'preparingTool'
  | 'image'
  | 'service'
  | 'computation'
  | ToolNarrationMessageKey
  | 'researchingInitial'
  | 'researching';

export type NarrationLine =
  | {
      kind: 'message';
      message: NarrationMessageKey;
      values?: Record<string, string | number>;
    }
  | { kind: 'authored'; text: string };

const NARRATION_MESSAGES: Record<NarrationMessageKey, MessageDescriptor> = {
  thinking: messages.thinking,
  working: messages.working,
  preparingTool: messages.activityPreparing,
  image: messages.activityImageWorking,
  service: messages.activityServiceWorking,
  computation: messages.activityComputationWorking,
  screenReady: messages.narrationScreenReady,
  savingDetails: messages.narrationSavingDetails,
  passingAlong: messages.narrationPassingAlong,
  lookingUp: messages.activitySearchWorking,
  checkingNotes: messages.narrationCheckingNotes,
  researchingInitial: messages.narrationResearchingInitial,
  researching: messages.narrationResearching,
};

export function messageNarration(
  message: NarrationMessageKey,
  values?: Record<string, string | number>,
): NarrationLine {
  return values ? { kind: 'message', message, values } : { kind: 'message', message };
}

export function authoredNarration(text: string): NarrationLine {
  return { kind: 'authored', text };
}

export function formatNarrationLine(line: NarrationLine | null, intl: IntlShape): string {
  if (!line) {
    return '';
  }
  if (line.kind === 'authored') {
    return line.text;
  }
  return intl.formatMessage(NARRATION_MESSAGES[line.message], line.values);
}
